import { Component } from '@angular/core';

@Component({
  selector: 'rr-card',
  standalone: false,

  templateUrl: './card.component.html',
  styleUrl: './card.component.scss'
})
export class CardComponent {

}
